// @flow
const next = <T>(x: T): T => x;
export default next;
